<template>
  <!-- Right Sidebar Panel Start -->
  <div id="chat-bot" :class="`right-sidebar-mini-chat ${miniClass}`">
    <div class="right-sidebar-panel p-0 h-100">
      <div class="iq-card shadow-none h-100">
        <div class="iq-card-body h-100">
          <div
            class="card tab-pane fade show active mb-0 h-100"
            id="user-content-101"
            role="tabpanel"
          >
            <!-- CHAT HEADER -->
            <div class="chat-head p-2">
              <header class="d-flex justify-content-between align-items-center px-3 py-1 header">
                <div class="d-flex align-items-center gap-3">
                  <div class="avatar-40 rounded-pill d-flex align-items-center justify-content-center bg-white text-primary font-size-16">
                    {{ chatbotName.trim().charAt(0).toUpperCase() }}
                  </div>
                  <div>
                    <h5 class="mb-0 ml-2 text-white">{{ chatbotName }}&nbsp;&nbsp;<sup>Beta</sup></h5>
                  </div>
                </div>
                 <div class="pull-right chat-header-close-icon">
                    <i @click="toggleMini" class="fa fa-times pointer text-white" aria-hidden="true"></i>
                  </div>
              </header>
            </div>

            <!-- CHAT BODY -->
            <div class="card-body chat-body bg-body p-2" ref="chatBody">
              <div class="chat-day-title text-center mb-3">
                <span>{{ new Date().toLocaleDateString('en-US', {year: 'numeric', month: 'short', day: 'numeric'}) }}</span>
              </div>
              <!-- chats -->
              <div
                v-for="(msg, index) in chatHistory"
                :key="index"
                :class="msg.role === 'user' ? 'iq-current-user iq-message-body' : 'iq-other-user iq-message-body'"
              >
                <!-- <div class="chat-profile text-center">
                  <div class="user-img" v-if="msg.role === 'user'">
                    <img
                      v-if="userData?.image"
                      :src="userData.image"
                      class="avatar-40 rounded-pill"
                      :alt="'user-avatar'"
                    />
                    <div v-else class="avatar-40 rounded-pill d-flex align-items-center justify-content-center bg-secondary text-primary fs-4">
                      {{ userData?.user_name?.trim()?.charAt(0).toUpperCase() }}
                    </div>
                  </div>
                  <div class="bot-img" v-else>
                    <div class="avatar-40 rounded-pill d-flex align-items-center justify-content-center bg-secondary text-primary fs-4">
                      {{ chatbotName.trim().charAt(0).toUpperCase() }}
                    </div>
                  </div>
                  <small>{{ new Date(msg.timestamp).toLocaleTimeString() }}</small>
                </div> -->

                <div class="iq-chat-text my-2">
                  <div class="iq-chating-content">

                    <!-- TYPING INDICATOR -->
                    <div v-if="msg.pending" class="typing-indicator">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>

                    <!-- NORMAL MESSAGE -->
                    <p v-else style="white-space: pre-line" class="">
                      {{ msg.content }}
                    </p>
                      <small class="mt-1">{{ new Date(msg.timestamp).toLocaleTimeString([], {hour: '2-digit',minute: '2-digit',hour12: false}) }}</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- CHAT FOOTER -->
            <div class="card-footer p-3">
              <div class="flex-wrap gap-2 mr-2">
                <span
                  v-for="item in smallSatQuestions"
                  :key="item.id"
                  class="badge mb-2 me-2 mr-2"
                  :class="[pendingIndex !== null ? 'bg-secondary disabled-badge' : 'bg-primary cursor-pointer']"
                  :title="item.question"
                  @click="pendingIndex === null && handlePromptClick(item.question)"
                >
                  {{ item.question }}
                </span>
              </div>
              <form @submit.prevent="handleUserQuerySubmit" class="d-flex align-items-center gap-2">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Ask your question"
                  v-model="userQuery"
                />
                <button :disabled="!userQuery || this.userQuery.trim() === '' || this.pendingIndex !== null" type="submit" class="btn btn-primary d-flex align-items-center send-button">
                  <i class="fa fa-paper-plane"></i>
                </button>
              </form>
            </div>
          </div>

          <!-- Toggle Button -->
          <b-btn
            class="right-sidebar-toggle mt-3"
            @click="toggleMini"
          >
            <template v-if="desktopView">
              <i class="fa-solid fa-arrow-left" v-if="rightSideBarMini"></i>
              <i class="fa-solid fa-arrow-right" v-else></i>
            </template>
            <template v-else>
              <i class="fa-solid fa-arrow-left" v-if="!rightSideBarMini"></i>
              <i class="fa-solid fa-arrow-right" v-else></i>
            </template>
          </b-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "../../../assets/images/logo.png"
import darkLoader from "../../../assets/images/logo-white.png"
import { mapActions } from "vuex"
import { ChatBots } from "../../../FackApi/api/quizBot"

export default {
  name: "ChatBot",
  data () {
    return {
      miniClass: "hide-right-side-bar-chat",
      showChat: true,
      animated: { enter: "zoomIn", exit: "zoomOut" },
      animateClass: [
        { value: { enter: "zoomIn", exit: "zoomOut" }, text: "Zoom" },
        { value: { enter: "fadeInUp", exit: "fadeOutDown" }, text: "Fade" },
        { value: { enter: "slideInLeft", exit: "slideOutRight" }, text: "Slide" },
        { value: { enter: "rotateInDownLeft", exit: "rotateOutDownLeft" }, text: "Roll" }
      ],
      smallSatQuestions: [
        {
          id: 1,
          question: "Give me a hint?",
          category: "Basics"
        },
        {
          id: 2,
          question: "Help me solve this question",
          category: "Orbit"
        },
        {
          id: 3,
          question: "More about the topic?",
          category: "Power"
        },
        {
          id: 4,
          question: "I need complete solution for the question",
          category: "Power"
        }
      ],
      logo: loader,
      rtl: false,
      users: [],
      showInterestModal: false,
      desktopView: false,
      rightSideBarMini: true,
      chatHistory: [
        { role: "assistant", content: "How can I assist you with your question?", timestamp: Date.now() }
      ],
      userQuery: "",
      pendingIndex: null,
      innerWidth: 0,
      chatbotName: "GideX"
    }
  },
  props: {
    toggleClass: {
      type: String,
      default: ""
    },
    propQuestion: {
      type: String
    },
    propIsMcq: {
      type: Boolean,
      default: false
    },
    propAnswerChoices: {
      type: Object,
      default: () => ({})
    },
    propQbkId: {
      type: String,
      default: ""
    },
    propModuleName: {
      type: String,
      default: ""
    }
  },
  computed: {
    refreshUserInterests () {
      return this.$store.state.User.refreshUserInterests
    },
    userData () {
      return this.$store.getters["User/userData"]
    },
    cleanedQuestion () {
      return this.removeEmptyTags(this.propQuestion)
    },
    chatbotPromptResponse () {
      return this.$store.getters["QuizBotMsg/getChatbotPromptResponse"]
    }
  },

  mounted () {
    this.desktopView = window.innerWidth > 1199
    this.innerWidth = window.innerWidth
    this.toggleMini()
  },

  methods: {
    /**
     * Handle the user query submission.
     */
    handleUserQuerySubmit () {
      if (this.userQuery && this.userQuery.trim() !== "") {
        this.getPromptResponse(this.userQuery)
      }
    },
    /**
     * Handle the click event for the prompt question.
     * @param userQuery The prompt question to get a response for.
     */
    handlePromptClick (userQuery) {
      if (userQuery && userQuery.trim() !== "") {
        this.getPromptResponse(userQuery)
      }
    },
    /**
     * Get the response for the given prompt question.
     * @param userQuery The prompt question to get a response for.
     */
    async getPromptResponse (userQuery) {
      // Show user message immediately in UI
      this.chatHistory.push({
        role: "user",
        content: userQuery,
        timestamp: Date.now()
      })

      // Add assistant typing indicator
      this.pendingIndex = this.chatHistory.push({
        role: "assistant",
        content: "",
        timestamp: Date.now(),
        pending: true
      }) - 1

      // Scroll to the bottom of the chat body
      this.scrollToBottom()

      // Prepare last 10 non-pending messages for GPT
      const recentChatHistory = this.chatHistory
        .filter(m => !m.pending) // exclude typing indicator
        .slice(-10) // keep only last 10 messages
        .map(m => {
          if (m.content.trim() !== "") {
            return { role: m.role, content: m.content }
          }
        })

      // payload for GPT
      const formattedChoices = this.formatAnswerChoices(this.propAnswerChoices)
      const payload = {
        module_name: this.propModuleName,
        qbk_id: this.propQbkId,
        is_mcq: this.propIsMcq,
        question: this.propQuestion,
        answer_choices: formattedChoices,
        userQuery: userQuery,
        history: recentChatHistory,
        chatbot_name: this.chatbotName
      }

      try {
        const response = await ChatBots.quizbotAskGpt(this, payload)
        if (response.resp_status) {
          // we need not to add anything here as we will receive response from socket by watcher
        }
        else {
          this.chatHistory[this.pendingIndex] = {
            role: "assistant",
            content: "Something went wrong. Please try again.",
            timestamp: Date.now()
          }
          this.pendingIndex = null
          this.scrollToBottom()
        }
      }
      catch (error) {
        this.chatHistory[this.pendingIndex] = {
          role: "assistant",
          content: "Something went wrong. Please try again.",
          timestamp: Date.now()
        }
        this.pendingIndex = null
        this.scrollToBottom()
        console.error("Error occurred while fetching GPT response:", error)
      }
      finally {
        this.userQuery = ""
      }
    },
    /**
     * Scroll to the bottom of the chat body.
     */
    scrollToBottom () {
      this.$nextTick(() => {
        const el = this.$refs.chatBody
        if (!el) return

        el.scrollTo({
          top: el.scrollHeight,
          behavior: "smooth"
        })
      })
    },
    formatAnswerChoices (choices) {
      if (!choices || typeof choices !== "object") return "N/A"

      return Object.entries(choices)
        .map(([key, value]) => {
          // strip HTML tags
          const text = value.replace(/<[^>]*>/g, "").trim()
          return `${key.toUpperCase()}. ${text}`
        }).join("\n")
    },

    /**
     * Remove empty HTML tags from a string.
     * @param html The HTML string to clean.
     * @returns The cleaned HTML string.
     */
    removeEmptyTags (html) {
      return html.replace(/<([a-z][a-z0-9]*)[^>]*>(\s|<br\s*\/?>)*<\/\1>/gi, "")
    },

    ...mapActions({
      modeChange: "Setting/layoutModeAction"
    }),
    toggleMini () {
      this.rightSideBarMini = !this.rightSideBarMini
      this.checkRightSideBar()

      this.$emit("emit-chatbotclose", this.rightSideBarMini)
    },

    checkRightSideBar () {
      this.miniClass = this.rightSideBarMini ? "right-sidebar" : "hide-right-side-bar-chat"
    },

    themeMode (mode) {
      this.modeChange({ rtl: this.rtl, dark: mode })
      this.logo = mode ? darkLoader : loader
      this.$emit("onLogo", this.logo)
    },

    rtlChange (mode) {
      this.rtl = mode
      this.modeChange({ rtl: mode, dark: this.darkMode })
      this.logo = this.darkMode ? darkLoader : loader
    },

    reset () {
      this.animated = { enter: "zoomIn", exit: "zoomOut" }
      this.themeMode(false)
      this.rtlChange(false)
    },

    openInterestModal () {
      this.showInterestModal = Math.random()
    },

    emitCloseInterestModal (addedNewInterests) {
      if (addedNewInterests) {
        this.$store.dispatch("User/refreshUserInterests")
      }
      this.showInterestModal = false
    },

    emitUserInterestsNotAdded () {
      this.showInterestModal = true
    }
  },
  watch: {
    chatbotPromptResponse (newVal) {
      if (!newVal || !newVal.prompt_response) {
        return
      }

      // store value in history
      this.chatHistory[this.pendingIndex] = {
        role: "assistant",
        content: newVal.prompt_response,
        timestamp: Date.now()
      }
      this.pendingIndex = null
      this.scrollToBottom()

      // Clear the response
      this.$store.dispatch("QuizBotMsg/removePromptResponse")
    },

    // on newValue of questionBank id reset chat history
    propQbkId (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.chatHistory = [{ role: "assistant", content: "How can I assist you with your question?", timestamp: Date.now() }]
      }
    }
  }
}
</script>

<style scoped>
.right-sidebar-mini-chat {
    top: 4.5rem;
    bottom: 0;
    z-index: 100;
    position: fixed;
    width: 18.75rem;
    right: 0;
    z-index: 1;
    transform: translateX(calc(111% - 2em));
    transition: all 0.3s ease-in-out;
}
@media screen and (min-width: 1200px) and (max-width: 1496px) {
  .hide-right-side-bar-chat {
    transform: translateX(100%) !important;
  }
}
.side-right-icon, .side-left-icon{
  color: #fff !important;
}
.chat-profile{
  display: grid;
  justify-items: center;
  align-items: center;
}
.iq-chating-content{
  display: inline-flex !important;
  padding-bottom: 15px;
}
.iq-current-user .iq-chating-content{
  background-color: var(--bs-secondary);
  border-radius: 10px 10px 0px 10px;
}
.iq-current-user .iq-chating-content small{
  position: absolute;
  bottom: 5px;
  right: 16px;
  font-size: 10px;
}
.iq-other-user .iq-chating-content small{
  position: absolute;
  bottom: 5px;
  left: 16px;
  width: 100%;
  font-size: 10px;
}
.iq-other-user .iq-chat-text{
  border-radius: 10px 10px 10px 0px;
}
.card-footer{
  background-color: #fff !important;
}
.material-symbols-outlined{
  color: var(--bs-secondary) !important;
}
.right-sidebar-mini-chat .card .card-body{
  padding-bottom: 20px;
  height: 100%;
}
@media screen and (min-width: 320px) and (max-width: 1200px){
  .right-sidebar-toggle{
    position: absolute;
    top: 50%;
  }
  .right-sidebar {
    /* transform: translateX(calc(0% - 1%)); */
    transform: unset !important;
    width: 100%;
  }
  .right-sidebar-mini-chat{
    top: 10px;
    bottom: 10px;
    right: 1px;
  }
}
@media screen and (min-width: 320px) and (max-width: 400px){
  .right-sidebar-toggle{
    align-self: unset;
  }
}
@media screen and (min-width: 1200px){
  .right-sidebar-mini-chat{
    width: 35%;
    bottom: 70px;
  }
  .right-sidebar-mini-chat{
    border: 1px solid var(--bs-border-color-translucent);
  }
}
@media screen and (max-width: 1200px){
  .chat-body{
    max-height: unset !important;
    min-height: unset !important;
  }
}
.right-sidebar-toggle{
  z-index: -1;
}

@media screen and (min-width: 1300px) and (max-width: 1600px){
  .right-sidebar{
    transform: translateX(calc(10% - 3em)) !important;
  }
}

/* chatbot typing indicator  */
.typing-indicator {
  display: inline-flex;
  gap: 4px;
  align-items: center;
}

.typing-indicator span {
  width: 8px;
  height: 8px;
  background-color: #6c757d; /* Bootstrap gray */
  border-radius: 50%;
  animation: typingBounce 1.4s infinite ease-in-out both;
}

.typing-indicator span:nth-child(1) {
  animation-delay: -0.32s;
}
.typing-indicator span:nth-child(2) {
  animation-delay: -0.16s;
}

.user-img, .bot-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
}

.disabled-badge {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

@keyframes typingBounce {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
#chat-bot{
  display: block;
}
.card{
  position: unset;
}
.chat-body {
  height: 100%;
  overflow-y: scroll;
  -o-object-fit: cover;
  object-fit: cover;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 0.5rem;
}
.right-sidebar-panel{
  border: 1px solid #e7e7e7;
  border-radius: 10px;
  box-shadow: none !important;
}
.iq-card{
  margin-bottom: 0px !important;
}
.iq-card-body{
  padding: 0px !important;
}
.chat-head{
  background-color: var(--iq-primary);
}
.iq-chating-content {
  max-width: 100%;
  padding: 0.625rem 1rem;
  background-color: var(--bs-gray-900);
  display: inline-flex !important;
}
.iq-other-user .iq-chating-content {
    border-radius: 0.5rem;
}
.iq-current-user.iq-chating-content {
    background-color: #d3d3d3;
}
.iq-other-user .iq-chat-text{
  background-color: #d3d3d3;
  position: relative;
}
.iq-current-user .iq-chat-text{
    background-color: #f1f1f1;
    position: relative;
    border-radius: 15px 15px 0px 15px;
}
.iq-message-body.iq-current-user{
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: row-reverse;
}
.iq-other-user.iq-message-body, .iq-current-user.iq-message-body {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 1rem;
    visibility: visible;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.right-sidebar-toggle{
  border-radius: 20px 10px 10px 20px !important;
  background-color: #e5252c !important;
}
.ight-sidebar-toggle:hover{
  background-color: #e5252c !important;
}
.send-button{
  height: 45px;
  margin-left: 8px;
}
.right-sidebar-panel .active{
  z-index: 9999 !important;
}
@media (min-width:1500px) {
  .right-sidebar-toggle {
    opacity: 1 !important;
    margin-left: -44px !important;
  }
  #chat-bot{
    right:40px;
  }
}
@media (min-width:1599px) {
  .right-sidebar-mini-chat{
    /* transform: unset; */
  }
}
/* .right-sidebar { transform: unset !important} */
</style>
